import { render, staticRenderFns } from "./MachinePerson.vue?vue&type=template&id=1556c92c&"
import script from "./MachinePerson.vue?vue&type=script&lang=js&"
export * from "./MachinePerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports